import { Injectable } from '@angular/core';
import { AccessToken } from '@models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public set accessToken(token: AccessToken | null) {
    localStorage.setItem('accessToken', JSON.stringify(token));
  }

  public get accessToken(): AccessToken | null {
    const token = localStorage.getItem('accessToken');
    return token ? JSON.parse(token) : null;
  }

  public set clientId(clientId: string) {
    localStorage.setItem('clientId', clientId);
  }

  public get clientId(): string {
    return localStorage.getItem('clientId') ?? '';
  }

  public clearTokens(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('clientId');
  }
}
